import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';

import { PRO_SUBSCRIBERS_ONLY, SUBSCRIBERS_ONLY } from './interfaces';

interface NewsletterImageProps {
  cardImageUrl: string;
  isProSubscribeOnly: boolean;
  isSubscribeOnly: boolean;
  previewDays: number;
}

const NewsletterImage = ({
  cardImageUrl,
  isProSubscribeOnly,
  isSubscribeOnly,
  previewDays,
}: NewsletterImageProps) => {
  const currentLabel = () => {
    if (isProSubscribeOnly) {
      return PRO_SUBSCRIBERS_ONLY;
    } else if (isSubscribeOnly) {
      return SUBSCRIBERS_ONLY;
    } else if (previewDays > 0 && previewDays < 999999) {
      return `${previewDays} day free trial`;
    }
  };
  return (
    <div className="relative flex flex-col">
      {currentLabel() && (
        <div
          className={clsx(
            'absolute top-0 w-full py-4 text-center font-suisse-intl-mono text-overline-sm text-white',
            {
              'bg-pro-gold': isProSubscribeOnly,
              'bg-primary-magenta': !isProSubscribeOnly,
            }
          )}
        >
          {currentLabel()}
        </div>
      )}

      <LazyImgixImage
        src={cardImageUrl}
        wrapperClassName="!flex max-h-[206px]"
        className="max-w-full object-cover"
      />
    </div>
  );
};

export default NewsletterImage;
